import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

// src/scene/GraphDefaults.tsx
var GraphDefaultsContext = React.createContext({});
function GraphDefaultsProvider({
  value,
  children
}) {
  const outer = React.useContext(GraphDefaultsContext);
  const merged = React.useMemo(() => ({ ...outer, ...value }), [outer, value]);
  return /* @__PURE__ */ jsx(GraphDefaultsContext.Provider, { value: merged, children });
}
function useGraphDefaults() {
  return React.useContext(GraphDefaultsContext);
}

export { GraphDefaultsProvider, useGraphDefaults };
//# sourceMappingURL=defaults.js.map
//# sourceMappingURL=defaults.js.map